import React, {useContext, useEffect, useState} from "react";
import {FormDataContext} from "../../contexts/FormDataContext";
import {nestTaxonomyChildren} from "../../utilities/NestTaxonomyChildren";
import { SectionHeading } from '../SectionHeading';
import { IntakeAutocomplete } from '../IntakeAutocomplete';


export const AttributesAutocomplete = () => {
  const [attributesWhoAreYouTraits, setAttributesWhoAreYouTraits] = useState([]);
  const [attributesWhoAreYouGroups, setAttributesWhoAreYouGroups] = useState([]);
  const {
    attributesAll,
    yourInterests,
    selectedAttributes,
    setSelectedAttributes,
    preferencesFormDisabled,
    setIsFormDataChanged,
  } = useContext(FormDataContext);

  useEffect(() => {
    if (attributesAll.length > 0) {
      let filteredAttributesWhoAreYou = attributesAll.filter(
        (attr) => !yourInterests.includes(attr.attribute_id)
      );
      let filteredAttributesYourInterests = attributesAll.filter(
        (attr) => yourInterests.includes(attr.attribute_id)
      );
      filteredAttributesWhoAreYou = nestTaxonomyChildren(
        filteredAttributesWhoAreYou,
        'attribute_id',
        'parent_attribute_id'
      );
      // filteredAttributesYourInterests = nestTaxonomyChildren(
      //   filteredAttributesYourInterests,
      //   'attribute_id',
      //   'parent_attribute_id'
      // );
      const filteredAttributesWhoAreYouTraits = filteredAttributesWhoAreYou.filter(
        attr => !attr.children
      );
      setAttributesWhoAreYouTraits(filteredAttributesWhoAreYouTraits);
      const filteredAttributesWhoAreYouGroups = filteredAttributesWhoAreYou.filter(
        attr => attr.children
      );
      setAttributesWhoAreYouGroups(filteredAttributesWhoAreYouGroups);
    }
  }, [attributesAll]);

  const transformGroupTitle = groupTitle => {
    let transformedTitle = '';
    switch (groupTitle) {
      case 'Student':
        transformedTitle = 'Student or Recent Grad?';
        break;
      default:
        transformedTitle = `Select ${groupTitle}`;
    }
    return transformedTitle;
  };

  return (
    <>
      <SectionHeading>
        Who Are You?
      </SectionHeading>
      {attributesWhoAreYouTraits.length > 0 &&
        <IntakeAutocomplete
          options={attributesWhoAreYouTraits}
          optionIdPropertyName="attribute_id"
          label="traits"
          selectedTaxonomyTermIds={selectedAttributes}
          setSelectedTaxonomyTermIds={setSelectedAttributes}
          disabled={preferencesFormDisabled}
        />
      }
      {attributesWhoAreYouGroups.map(attrGroup => (
          <IntakeAutocomplete
            key={attrGroup.attribute_id}
            options={attrGroup.children}
            optionIdPropertyName="attribute_id"
            fullLabel={transformGroupTitle(attrGroup.name)}
            selectedTaxonomyTermIds={selectedAttributes}
            setSelectedTaxonomyTermIds={setSelectedAttributes}
            disabled={preferencesFormDisabled}
          />
        )
      )}
    </>
  );
}
